module.exports = __webpack_public_path__ + "static/media/sidebar-case-history-selected.6847b98e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/sidebar-case-history-selected.svg
// module id = 794
// module chunks = 0